import { minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

export const image = css`
  display: block;
  width: 110px;
  height: 28px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      width: 157px;
      height: 40px;
    `,
  )}
`;
